export function formatAneelUc(value: number | string): string {
    let str = value.toString().replace(/^0+/, '') || '0';
    if (str.length !== 15) {
        return value.toString();
    }

    const parte1 = str.substring(0, 1);
    const parte2 = str.substring(1, 4);
    const parte3 = str.substring(4, 7);
    const parte4 = str.substring(7, 10); 
    const parte5 = str.substring(10, 13);
    const parte6 = str.substring(13, 15);

    return `${parte1}.${parte2}.${parte3}.${parte4}.${parte5}-${parte6}`;
}